import { render, staticRenderFns } from "./cashReject.vue?vue&type=template&id=3bfc124c"
import script from "./cashReject.vue?vue&type=script&lang=ts"
export * from "./cashReject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports